import "./fixed_btn.css";
import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import _ from "lodash";

function FixedBtn() {
  const [cookie, setCookie, removeCookie] = useCookies(["admin"]);

  const callCenter = () => {
    document.location.href = "tel:041-575-7651";
  };
  const moveToTop = () => {
    document.documentElement.scrollTop = 0;
  };

  const handleLogout = (event: React.MouseEvent<HTMLButtonElement>) => {
    removeCookie("admin");
    alert("로그아웃 되었습니다.");
  };

  const loginBtn = (
    <button className="fixed_btn" id="manager">
      <Link to="/login">
        <span className="material-symbols-outlined fixed_icon">
          manage_accounts
        </span>
      </Link>
    </button>
  );

  const logoutBtn = (
    <button className="fixed_btn" id="manager" onClick={handleLogout}>
      <span className="material-symbols-outlined fixed_icon">logout</span>
    </button>
  );

  return (
    <div className="fixed_btn_container">
      <button className="fixed_btn" id="top" onClick={moveToTop}>
        <span className="material-symbols-outlined fixed_icon">
          vertical_align_top
        </span>
      </button>
      <button className="fixed_btn" id="tel" onClick={callCenter}>
        <span className="material-symbols-outlined fixed_icon">
          phone_in_talk
        </span>
      </button>
      <button className="fixed_btn" id="home">
        <Link to="/">
          <span className="material-symbols-outlined fixed_icon">home</span>
        </Link>
      </button>
      {_.isEmpty(cookie) ? loginBtn : logoutBtn}
    </div>
  );
}

export default FixedBtn;
